// CircleProgressBar.js
import React, { useState, useEffect } from 'react';

let interval;

const CircleProgressBar = (props) => {
    const { size, strokeWidth, color, children, endTime, totalDuration, onComplete } = props;
    const [progress, setProgress] = useState(0);
    const [remainingTime, setRemainingTime] = useState(0);

    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;

    // Calculate the strokeDashoffset based on the progress
    const strokeDashoffset = circumference - (progress / 100) * circumference;

    const calculateProgress = () => {
        const currentTime = Date.now();
        const elapsedTime = (currentTime - (endTime - totalDuration * 1000)) / 1000;
        const remainingDuration = (endTime - currentTime) / 1000;

        if (remainingDuration <= 0) {
            setProgress(100);
            setRemainingTime(0);
            clearInterval(interval);
            if (onComplete) onComplete();
        } else if (elapsedTime >= 0) {
            const newProgress = (elapsedTime / totalDuration) * 100;
            setProgress(newProgress);
            setRemainingTime(remainingDuration);
        }
    };

    useEffect(() => {
        calculateProgress(); // محاسبه اولیه
        interval = setInterval(calculateProgress, 100); // به روزرسانی هر 100 میلی‌ثانیه

        return () => clearInterval(interval); // پاکسازی تایمر هنگام خروج از کامپوننت
    }, [endTime, totalDuration]);

    return (
        <div
            className="circular-progress-container"
            style={{ width: size, height: size, position: 'relative' }}
        >
            <svg width={size} height={size} style={{ transform: 'rotate(-90deg)' }}>
                {/* پس زمینه دایره */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke="transparent"
                    fill="transparent"
                    strokeWidth={strokeWidth}
                />
                {/* دایره پیشرفت */}
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    stroke={color}
                    fill="transparent"
                    strokeWidth={strokeWidth}
                    strokeDasharray={circumference}
                    strokeDashoffset={strokeDashoffset}
                    strokeLinecap="round"
                    style={{ transition: 'stroke-dashoffset 0.5s ease' }}
                />
            </svg>
            <div
                className="inner-button"
                style={{width: size - 1}}
            >
                {children}
            </div>
        </div>
    );
};

export default CircleProgressBar;
